import type { ChannelFactory } from './session-core';
import type { CrossTabChannel } from './session-core';
import type { SessionSyncMessage } from './session-core';

export const createBroadcastChannelFactory: ChannelFactory = (channelName, onMessage): CrossTabChannel | null => {
  if (typeof BroadcastChannel === 'undefined') {
    return null;
  }
  let channel: BroadcastChannel | null = null;
  try {
    channel = new BroadcastChannel(channelName);
  } catch {
    return null;
  }
  channel.onmessage = (event) => {
    const message = event.data as SessionSyncMessage;
    if (message && typeof message.type === 'string') {
      onMessage(message);
    }
  };
  const openChannel = channel;
  const post = (message: SessionSyncMessage): void => {
    try {
      openChannel.postMessage(message);
    } catch {
      // BroadcastChannel may be closed
    }
  };
  const close = (): void => {
    try {
      openChannel.close();
    } catch {
      // BroadcastChannel may already be closed
    }
  };
  return { post: post, close: close };
};
